import React from 'react';
import { UncontrolledTooltip } from 'reactstrap';
import moment from 'moment';
import cls from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendarTimes } from '@fortawesome/free-solid-svg-icons';

export default class LongTermStatusIndicator extends React.Component {
    getEffectiveLongTermStatus = () => {
        const { longTermStatuses } = this.props;

        if (!longTermStatuses || !longTermStatuses.length) {
            return null;
        }

        const employeeLongTermStatus = this.getEmployeeLongTermStatus();

        if (!employeeLongTermStatus) {
            return null;
        }

        return longTermStatuses.find(
            (lts) => employeeLongTermStatus.longTermStatusId == lts.id,
        );
    };

    getEmployeeLongTermStatus = () => {
        const {
            staff,
            employeeLongTermStatuses,
            selectedWeekRangeDays,
        } = this.props;

        if (
            !staff ||
            !employeeLongTermStatuses ||
            !employeeLongTermStatuses.length
        ) {
            return null;
        }

        // Works for both employees and equipment
        const employeeStatuses = employeeLongTermStatuses.filter(
            (elts) => staff.id == elts.employeeId || staff.id == elts.equipmentId,
        );

        if (!employeeStatuses.length) {
            return null;
        }

        const selectedDays = (selectedWeekRangeDays || []).map((d) =>
            moment(d).startOf('day'),
        );

        if (!selectedDays.length) {
            return employeeStatuses
                .slice()
                .sort((a, b) => moment(b.startDate).diff(moment(a.startDate)))[0];
        }

        const matchingStatus = employeeStatuses.find((elts) => {
            const startDayUtc = moment(elts.startDate).startOf('day');
            const endDayUtc = elts.endDate
                ? moment(elts.endDate).endOf('day')
                : null;

            return selectedDays.some((day) => {
                if (!endDayUtc) {
                    return day.isSameOrAfter(startDayUtc, 'day');
                }
                return day.isBetween(startDayUtc, endDayUtc, 'day', '[]');
            });
        });

        return matchingStatus || null;
    };

    getStatusDateRange = () => {
        const employeeLongTermStatus = this.getEmployeeLongTermStatus();

        if (!employeeLongTermStatus) {
            return null;
        }

        const startDate = moment(employeeLongTermStatus.startDate)
            .toDate()
            .toLocaleDateString();

        if (!employeeLongTermStatus.endDate) {
            return `(${startDate} - Current)`;
        }

        const endDate = moment(employeeLongTermStatus.endDate)
            .toDate()
            .toLocaleDateString();

        return `(${startDate} - ${endDate})`;
    };

    render() {
        const { staff } = this.props;

        const effectiveLongTermStatus = this.getEffectiveLongTermStatus();

        if (!effectiveLongTermStatus) {
            return null;
        }

        const longTermStatusName = effectiveLongTermStatus?.name;
        const dateRange = this.getStatusDateRange();

        const extraClass =
            effectiveLongTermStatus && !effectiveLongTermStatus.allowDispatch
                ? 'text-danger'
                : '';

        return (
            <>
                <FontAwesomeIcon
                    icon={faCalendarTimes}
                    className={cls('cursor-pointer', extraClass)}
                    id={`lts-${staff.id}`}
                />

                <UncontrolledTooltip target={`lts-${staff.id}`}>
                    {`${longTermStatusName} - ${dateRange}`}
                </UncontrolledTooltip>
            </>
        );
    }
}
